import logoT from "../assets/logo/logo-t-2.png"
import { Link } from "react-router-dom"

export const LogoForProjects = () => {
    return (
        <Link to="/">
            <div className="flex items-center gap-3 pt-[2.2rem]">
                <img src={logoT} alt="" className="h-[2rem] object-cover" />
                <span className="text-[#272727] font-spaceGrotesk text-[18px] font-normal mt-[5px]">thoby.za</span>
            </div>
        </Link>
    )
}